<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-ecomTool-amzCtnPdf',
  components: { PageTable },
}
</script>
